import { render, staticRenderFns } from "./Wp_message_card_like_weixin.vue?vue&type=template&id=38ac650e&scoped=true&"
import script from "./Wp_message_card_like_weixin.vue?vue&type=script&lang=js&"
export * from "./Wp_message_card_like_weixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac650e",
  null
  
)

export default component.exports